import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e24f4e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = { class: "modal-card-head" }
const _hoisted_4 = { class: "modal-card-title is-title-shrink" }
const _hoisted_5 = { class: "modal-card-body" }
const _hoisted_6 = { class: "modal-card-foot custom-modal-card-foot is-justify-content-flex-end" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MoneyTransaction = _resolveComponent("MoneyTransaction")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal is-active",
    tabindex: "0",
    onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.isValid ? _ctx.openQrCode() : null), ["enter"]))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$gettext("Request money")), 1),
        _createElementVNode("button", {
          class: "delete",
          "aria-label": "close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
        })
      ]),
      _createElementVNode("section", _hoisted_5, [
        _createVNode(_component_MoneyTransaction, {
          directionTransfer: "receive",
          account: _ctx.account,
          selectedRecipient: _ctx.selectedRecipient,
          config: _ctx.config,
          transactionType: "createRequestPay",
          "onUpdate:amount": _cache[1] || (_cache[1] = (x) => (_ctx.amount = x)),
          "onUpdate:senderMemo": _cache[2] || (_cache[2] = (x) => (_ctx.senderMemo = x)),
          "onUpdate:recipientMemo": _cache[3] || (_cache[3] = (x) => (_ctx.recipientMemo = x)),
          "onUpdate:isValid": _cache[4] || (_cache[4] = (x) => (_ctx.isValid = x))
        }, null, 8, ["account", "selectedRecipient", "config"])
      ]),
      _createElementVNode("footer", _hoisted_6, [
        _createElementVNode("button", {
          disabled: !_ctx.isValid,
          class: "button custom-button-modal has-text-weight-medium",
          id: "send-money-button",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openQrCode()))
        }, _toDisplayString(_ctx.$gettext("Generate QR code")), 9, _hoisted_7)
      ])
    ])
  ], 32))
}